import { useCurrentStateAndParams } from "@uirouter/react";

import { isModuleSupportSegments } from "app/pages/industry-analysis/common/isModuleSupportSegments";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import { usePrimaryCategoryObject } from "../common/hooks/usePrimaryCategoryObject";

export const WithRedirectToMarketResearchOverview = (Component) => {
    return function WrappedComponent(props) {
        const { state, params } = useCurrentStateAndParams();
        const categoryObject = usePrimaryCategoryObject();
        const hasSegments = CategoryServiceUtils.hasSegments(categoryObject);

        if (hasSegments && (!isModuleSupportSegments() || state.segmentsSupport === false)) {
            // For segments, respect the custom industry's country if set, otherwise default to worldwide
            // This prevents filter consistency from defaulting to the first country in the list (Austria - 40)
            const customIndustryCountry = categoryObject?.country;
            const redirectCountry = customIndustryCountry || WORLDWIDE_COUNTRY_ID;

            void proNavigator.go("market_research_overview_v2", {
                ...params,
                webSource: "Total",
                country: redirectCountry,
                ignoreFilterConsistency: true,
            });
        }
        return <Component {...props} />;
    };
};
